import { render, staticRenderFns } from "./ConductorMovilidad.vue?vue&type=template&id=0b257f53&scoped=true&"
import script from "./ConductorMovilidad.vue?vue&type=script&lang=js&"
export * from "./ConductorMovilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b257f53",
  null
  
)

export default component.exports